import React from 'react'
import { Link } from 'react-router-dom';
const Navbar = () => {
    return (
        <div className="sticky-top shadow">
            <nav className="navbar navbar-expand-md navbar-dark  bg-dark" >
                <div className="container-fluid ">
                    <Link className="navbar-brand" to="#">Complaint/Installation</Link>
                    {/* <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button> */}
                    <div className="collapse navbar-collapse" id="navbarSupportedContent">
                        <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                            <li className="nav-item">
                                <Link className="nav-link" aria-current="page" to="/">Home</Link>
                            </li>
                            <li className="nav-item">
                                <Link className="nav-link" to="/complaintform">Complaint_Form</Link>
                            </li>    
                            <li className="nav-item">
                                <Link className="nav-link" to="/complaints">complaints</Link>
                            </li>                                                   
                        </ul>
                        <form className="d-flex">
                            <input className="form-control me-2" type="search" placeholder="Search" aria-label="Search"/>
                            <button className="btn btn-outline-success" type ="submit">Search</button>
                        </form>
                    </div>
                </div>
            </nav>
        </div>
    )
}

export default Navbar
